import { Avatar } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import PubNub from "pubnub";
import './SidebarOption.css'
import common from "../config/common.json"
import getGlobalVarContext from "../context/getGlobalVarContext";
import { LoadingSpinner } from "../loadingSpinner/newLodingSpinner/LoadingSpinner"
import { useIntl } from 'react-intl';

var groupChat = []
var personalChat = []
var pubnumsubObject = ""
var storeChannalName = []
function SidebarOption() {
  const { setGlobalVar, globalVar } = useContext(getGlobalVarContext());
  const { personalChannel, groupList, subID, newPersonalsearchList, newGroupsearchList } = globalVar
  const [isLoadingForGroup, setIsLoadingForGroup] = useState(false);
  const [isLoadingForPersonalChat, setIsLoadingForPersonalChat] = useState(false);
  const intl = useIntl()
  const [pubnub, setPubnub] = useState()
  async function directMessages(pubnubObj) {
    setPubnub(pubnubObj)
    setIsLoadingForPersonalChat(true)
    var requestOptions = {
      method: "GET"
    };
    var channelname = []

    var promise = new Promise((resolve, reject) => {

      fetch(
        `${common.BASEURL}/user/myfriend?user_id=${subID !== null ? subID : localStorage.getItem("sub")}`,
        requestOptions
      ).then(response => response.text())
        .then(async result => {
          var data = JSON.parse(result)
          if (data.msg.length === 0) {
            setIsLoadingForPersonalChat(false)
          }
          // let waitForCount=0;
          for (const item of data.msg) {

            if (item.status === intl.formatMessage({ id: "accept" })) {
              if (item.user_email !== undefined && item.friend_email !== undefined) {
                var name = item.user_id === localStorage.getItem("sub")? item.friend_name : item.user_name
                var email = item.user_email === localStorage.getItem("email") ? item.friend_email : item.user_email
                var uuid = item.user_id === localStorage.getItem("sub") ? item.friend_id : item.user_id
                item.uuid = uuid
                var profile = item.user_id === localStorage.getItem("sub") ? item.friend_url : item.user_url
                if (profile !== undefined) {
                  item.user_url = profile.includes("http") === true ? profile : ""

                } else {
                  item.user_urlgroup_name = ""
                }

                if (item.channel_name === undefined) {
                  // console.log(item.user_url)
                  var user_data = email.replace(/@/g, "")
                  var user_email = localStorage.getItem("email").replace(/@/g, "")
                  // var commonChannel = [];
                  var userEmailList = []
                  userEmailList = userEmailList.concat(user_email)
                  userEmailList = userEmailList.concat(user_data)

                  userEmailList.sort();
                  item.group_name = `${userEmailList[0]}${userEmailList[1]}`
                  item.group_name = (item.group_name).trim().replace(/[^a-zA-Z0-9 ]/g, "")
                  item.user_name = name
                  item.chat_type = intl.formatMessage({ id: "personalChat" })
                }
                else {
                  item.user_name = name
                  item.chat_type = intl.formatMessage({ id: "personalChat" })
                  item.group_name = item.channel_name
                }
                storeChannalName.push(item.group_name)
                await pubnubObj.subscribe({
                  channels: [item.group_name],
                  withPresence: true
                });
                channelname.push(item)
              }

            }

          }
          resolve(channelname)
          setIsLoadingForPersonalChat(false)
        }).catch(error => {
          setIsLoadingForPersonalChat(false)
          console.log("error8888", error);
        });
    })

    await promise.then(async (data) => {
      setIsLoadingForPersonalChat(false)
      personalChat = data
      setGlobalVar((oldData) => ({
        ...oldData,
        personalChannel: data,
        newPersonalsearchList: personalChat,
      }));
      var newList = []
      
      const getUserStatus = await pubnumsubObject.hereNow({
        // channels: [item["group_name"]],
        channels: storeChannalName,
        includeUUIDs: true,
        includeState: true,
      });
      let msgCount;
      let count=0
  
      personalChat.forEach(async(item) => {
        count =count +1
      msgCount = await pubnumsubObject.messageCounts({
        channels: storeChannalName,
        channelTimetokens: [item.user_id === subID ?item.user_timestamp:item.friend_timestamp]
      })
      for (let item of personalChat) {
        try {
          if (msgCount.channels[item.group_name] && msgCount.channels[item.group_name] !== 0) {
            item.count = `${msgCount.channels[item.group_name]}`

          } else {
            item.count = `${msgCount.channels[item.group_name]}`
          }
          if (getUserStatus.channels[item.group_name] && getUserStatus.channels[item.group_name].occupancy > 0) {
            var user_local_id = subID === null ? localStorage.getItem("sub") : subID
            // eslint-disable-next-line no-loop-func
            let checkPresence = getUserStatus.channels[item.group_name].occupants.filter(res => res.uuid !== user_local_id)[0];
            if (checkPresence !== undefined && checkPresence.uuid === item.uuid) {
              item.presence = true;
            }
            else {
              item.presence = false;
            }
          } else {
            item.presence = false;
          }
          if (item.count !== 0) {
            newList.unshift(item)
          } else {
            newList.push(item)
          }
        } catch (e) {
          console.log(e)
        }
      }
      if(count === personalChat.length){
        personalChat = newList
        setGlobalVar((oldData) => ({
          ...oldData,
          personalChannel: newList,
          newPersonalsearchList: newList,
        }));
        newList = []
      }
      })
    })

  }
  async function getMyGroup(pubnubObj) {
    setIsLoadingForGroup(true)
    var requestOptions = {
      method: "POST",
      body: JSON.stringify({ "user_id": subID !== null ? subID : localStorage.getItem("sub") })
    };
    var grouplist = []
    var promise = new Promise((resolve, reject) => {


      fetch(
        `${common.BASEURL}/user/group`,
        requestOptions
      ).then(response => response.text())
        .then(async result => {

          var data = JSON.parse(result)
          // console.log(data)
          if (data.msg.length === 0) {
            setIsLoadingForGroup(false)
          }
          let waitForCount = 0;

          // eslint-disable-next-line array-callback-return
          data.msg.map(async (item) => {
            if (item.role !== intl.formatMessage({ id: "remove" }) && item.group_name !== undefined) {
              var group_name;
              item.newgroup = item.group_name
              var n = item.group_name.includes(" ");
              if (n === true) {
                group_name = item.group_name.replace(/ /g, "-msg")
              } else if (n === false) {
                group_name = item.group_name
              }
              if (item.channel_name !== undefined) {
                group_name = item.channel_name
              }
              item.chat_type = "group"
              item.user_url = ""
              item.group_name = group_name
              item.count=0
              pubnubObj.messageCounts(
                {
                  channels: [group_name],
                  channelTimetokens: [item.user_id === subID ?item.user_timestamp:item.friend_timestamp]
                },
                async (status, count) => {
                  // eslint-disable-next-line eqeqeq
                  if (count != undefined) {
                    item.count = count.channels[group_name]
                    if (Number(item.count) !== 0) {
                      console.log(item.count)
                      grouplist.unshift(item)
                      
                    } else {
                      grouplist.push(item)
                    }
                  } else {
                    grouplist.push(item)
                  }

                  waitForCount = waitForCount + 1
                  await pubnubObj.subscribe({
                    channels: [group_name],
                    withPresence: true
                  });
                  if (data.msg.length === waitForCount) {
                    setIsLoadingForGroup(false)
                    resolve(grouplist)
                  }

                }
              );
            } else {
              waitForCount = waitForCount + 1

            }
          })
        }).catch(error => {
          setIsLoadingForGroup(false)
          console.log("error8888", error);
        });


    })
    await promise.then((data) => {
      // setGroup(data)
      setIsLoadingForGroup(false)
      groupChat = data
      setGlobalVar((oldData) => ({
        ...oldData,
        groupList: grouplist,
        newGroupsearchList: grouplist,


      }));
    })
  }

  async function listUserData(group_info) {
    var raw = JSON.stringify({
      group_name: group_info.group_name,
    });
    var requestOptions = {
      method: "POST",
      body: raw
    };
    var res = await fetch(
      `${common.BASEURL}/user/list`,
      requestOptions
    );
    var response = await res.json();
    var data = response;
    if (data.msg.length > 0) {
      setGlobalVar((oldData) => ({
        ...oldData,
        groupUserList: data.msg,
        data: group_info,
        renderView: true,
        pubnub: pubnub
      }));
    } else {
      setGlobalVar((oldData) => ({
        ...oldData,
        groupUserList: [],
        data: group_info,
        renderView: true,
        pubnub: pubnub
      }));
    }
  }
  const updateUserTimestamp = async(data, chatName) => {
    let body = {
      timestamp: new Date().getTime() * 10000,
      chat_type: chatName,
      group_role: chatName === "group"?data.role :"user",
      userId: data.user_id,
      sub: localStorage.getItem("sub"),
      createdDate : data.created_date
    };
    let requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
    };
    try {
      const result = await fetch(`${common.BASEURL}/user/update/timestamp`,requestOptions);
      // navigate("/chat")
      viewChatPage(data, chatName)
    } catch (error) {
      // navigate("/chat")
      console.log(error);
      viewChatPage(data, chatName)
    }
  };
  function viewChatPage(data, chatName) {
    setGlobalVar((oldData) => ({
      ...oldData,
      groupUserList: [],
    }));
    if (chatName === intl.formatMessage({ id: "groupChat" })) {
      localStorage.setItem("groupType", true)

      listUserData(data);

    } else {
      localStorage.setItem("groupType", false)

      setGlobalVar((oldData) => ({
        ...oldData,
        groupUserList: [],
        data: data,
        renderView: true,
        pubnub: pubnub
      }));
    }
    var getTimestamp = new Date().getTime() * 10000;
    localStorage.setItem("logoutTime", getTimestamp.toString());

    localStorage.setItem("channelName", data.group_name);
    if (chatName === intl.formatMessage({ id: "groupChat" })) {
      // eslint-disable-next-line array-callback-return
      groupList.map((item, index) => {
        if (item.group_name === data.group_name) {
          groupList[index].count = 0;
          setGlobalVar((oldData) => ({
            ...oldData,
            groupList: groupList
          }));
          groupChat = groupList

        }
      })
    } else if (chatName === intl.formatMessage({ id: "personalChat" })) {
      // eslint-disable-next-line array-callback-return
      personalChannel.map((item, index) => {
        if (item.group_name === data.group_name) {
          personalChannel[index].count = 0;
          setGlobalVar((oldData) => ({
            ...oldData,
            personalChannel: personalChannel,
            newPersonalsearchList: personalChannel
          }));
          personalChat = personalChannel

        }
      })
    }
  }
  useEffect(() => {
    localStorage.removeItem("channelName")
    const pubnub = new PubNub({
      publishKey: common.publishKey,
      subscribeKey: common.subscribeKey,
      uuid: localStorage.getItem("sub"),
      presenceTimeout: 60
    });
    pubnumsubObject = pubnub
    setPubnub(pubnub)
    getMyGroup(pubnub)
    directMessages(pubnub)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pubnub !== undefined) {
      var listener = {
        message: (message) => {
          if (message) {
            var getTimestamp = new Date().getTime() * 10000;
            localStorage.setItem("logoutTime", getTimestamp)
            var newGroupList = []
            var newpersonalChat = []
            if (localStorage.getItem("channelName") !== message.channel && message.message.publisher !== localStorage.getItem("email")) {
              if (message?.message?.chat === intl.formatMessage({ id: "groupChat" })) {
                var count = 0
                // eslint-disable-next-line array-callback-return
                groupChat.map((item, index) => {
                  if (item.group_name === message.channel) {
                    count = count + 1
                    item.count = Number(item.count) + 1
                    newGroupList.unshift(item)
                  }
                  else {
                    count = count + 1
                    newGroupList.push(item)
                  }
                  if (newGroupList.length === groupChat.length) {
                    setGlobalVar((oldData) => ({
                      ...oldData,
                      groupList: newGroupList,
                      newGroupsearchList: newGroupList
                    }))
                    groupChat = newGroupList
                    return 0
                  }

                })

              }
            }
            if (localStorage.getItem("channelName") !== message.channel && message.message.publisher !== localStorage.getItem("email")) {
              if (message?.message?.chat === intl.formatMessage({ id: "personalChat" }) || message?.message?.personal === intl.formatMessage({ id: "personalChat" })) {
                // eslint-disable-next-line array-callback-return
                // eslint-disable-next-line array-callback-return
                // eslint-disable-next-line array-callback-return
                personalChat.map((item, index) => {
                  if (item.group_name === message.channel) {
                    item.count = Number(item.count) + 1
                    newpersonalChat.unshift(item)
                  } else {
                    newpersonalChat.push(item)
                  }
                  if (newpersonalChat.length === personalChat.length) {
                    setGlobalVar((oldData) => ({
                      ...oldData,
                      personalChannel: newpersonalChat,
                      newPersonalsearchList: newpersonalChat
                    }))
                    personalChat = newpersonalChat
                    return 0
                  }

                })
              }

            }
          }
        },
        presence: async (event) => {
          var newList = []
          for (let val of personalChat) {
            try {
              if (event.action === intl.formatMessage({ id: "join" }) && event.uuid !== localStorage.getItem("sub") && event.channel.includes("personal") && val.uuid === event.uuid) {
                val.presence = true
              } else if (event.action === intl.formatMessage({ id: "leave" }) && event.uuid !== localStorage.getItem("sub") && event.channel.includes("personal") && val.uuid === event.uuid) {
                val.presence = false
              } else if (event.action === intl.formatMessage({ id: "timeout" }) && event.uuid !== localStorage.getItem("sub") && event.channel.includes("personal") && val.uuid === event.uuid) {
                val.presence = false
              } else if (event.action === intl.formatMessage({ id: "interval" }) && event.uuid !== localStorage.getItem("sub") && event.channel.includes("personal") && val.uuid === event.uuid) {
                val.presence = false
              }
              newList.push(val)
            } catch (e) {
              console.log(e)
            }


          }
          setGlobalVar((oldData) => ({
            ...oldData,
            personalChannel: newList,
            newPersonalsearchList: newList,
          }));
          newList = []
        }
      }
      pubnub.addListener(listener); // <-- pass the listener here
      return function cleanup() {
        pubnub.removeListener(listener); // <-- pass the same listener here
        pubnub.unsubscribeAll();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pubnub]);
  const inputEvent = (e) => {
    const listItem = e.target.value;
    var newData = []
    newData = newData.concat(groupList);
    newData = newData.concat(personalChannel);
    var newPersonaldata = []
    var newGroupdata = []
    if (listItem.length !== 0) {

      newData.map((item) => {
        if (item.chat_type === intl.formatMessage({ id: "personalChat" })) {
          var name = item.user_name === localStorage.getItem("name") ? item.friend_name : item.user_name;
          if ((name.toUpperCase()).indexOf(listItem.toUpperCase()) > -1) {
            newPersonaldata.push(item)
          }
        } else if (item.chat_type === intl.formatMessage({ id: "groupChat" })) {
          if ((item.newgroup.toUpperCase()).indexOf(listItem.toUpperCase()) > -1) {
            // console.log(item,"group")
            newGroupdata.push(item)
          }
        }
      })
      setGlobalVar((oldData) => ({
        ...oldData,
        newPersonalsearchList: newPersonaldata,
        newGroupsearchList: newGroupdata
      }));
    } else {
      setGlobalVar((oldData) => ({
        ...oldData,
        newPersonalsearchList: personalChannel,
        newGroupsearchList: groupList,
      }));
    }
  }
  return (
    <>
      <div className='member_chat'>
        <input id='selected' className='serchinput' placeholder={intl.formatMessage({ id: "search" })} onChange={inputEvent} />
        <div className='grouptitle'>
          <h2>{intl.formatMessage({ id: "groupListLable" })}</h2></div>

        {isLoadingForGroup ? (
          <LoadingSpinner />
        ) : (
          <div className='scroll'>
            {newGroupsearchList.map((item, index) => {
              return (
                <div onClick={e =>{ updateUserTimestamp(item, "group"); 
                 viewChatPage(item, "group");} } className={`sidebarOption`} key={index}>
                  <div className='sidebarright'
>
                    <Avatar src={item.user_url} style={{ background: item.user_url === "" ? common.autoColorGenerator[Math.floor(Math.random() * common.autoColorGenerator.length)] : "#bdbdbd" }}>{intl.formatMessage({ id: "groupProfileIcon" })}</Avatar>
                    <p className={item.newgroup.length > 15 ? 'textoverflow' : 'sidbar_list'}>{item.newgroup}</p>
                  </div>

                  <div className='notifictionicon'>
                    <span className={item?.count > 0 ? "notifiction" : "notifiction-display"} id={item.group_name} >{item.count}</span>
                  </div>
                </div>
              );
            })}
          </div>)}
      </div>
      <div className='groupchat'>
        <div className='grouptitle'>
          <h2>{intl.formatMessage({ id: "directMessagesListLable" })}</h2></div>
        {isLoadingForPersonalChat ? (
          <LoadingSpinner />
        ) : (
          <div className='bottomscrollsidebar'>
            {newPersonalsearchList?.map((item, index) => {
              return (
                <div onClick={e =>{updateUserTimestamp(item, "personal"); viewChatPage(item, "personal")}} className={`sidebarOption`} key={index}>

                  <div className='sidebarright'>
                    <Avatar src={item.user_url} style={{ background: item.user_url === "" ? common.autoColorGenerator[Math.floor(Math.random() * common.autoColorGenerator.length)] : "#bdbdbd" }} >{intl.formatMessage({ id: "groupListLable" })}</Avatar>
                    <div className={item.presence === true ? "online_icon" : "offline_icon"}> </div>
                    <p className={item.user_name.length > 15 ? 'textoverflow' : 'sidbar_list'}>{item.user_name}</p>
                  </div>
                  <div className='notifictionicon'>
                    <span className={item?.count > 0 ? "notifiction" : "notifiction-display"} >{item.count}</span>
                  </div>
                </div>

              );
            })}
          </div>)}
      </div>
    </>
  )
}

export default SidebarOption